"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var client_1 = require("./resources/client");
var user_1 = tslib_1.__importDefault(require("./resources/user"));
var logger_1 = require("./logger");
var base_1 = tslib_1.__importDefault(require("./resources/base"));
var resources = tslib_1.__importStar(require("./resources"));
var events_1 = require("events");
var Sigma = /** @class */ (function () {
    /**
     * Create a new custom Sigma instance with a specific hostname
     * Warning: Creating a new instance in this way will not take advantage
     * of global caching across apps/web components. Each new instance of Sigma
     * will have its own set of resources and their own cache
     * @param hostname
     * @param token
     */
    function Sigma(hostname, token) {
        var _a;
        this.hostname = hostname;
        var newClient = new client_1.SigmaAPIClient(this.hostname, token);
        this.client = newClient;
        // Variable to deal with local iterating of resources imported at the top of this file
        var importedResources = resources;
        var resourceClasses = {};
        for (var key in resources) {
            var ResourceClass = importedResources[key];
            if (ResourceClass) {
                resourceClasses[key] = (_a = /** @class */ (function (_super) {
                        tslib_1.__extends(class_1, _super);
                        function class_1() {
                            return _super !== null && _super.apply(this, arguments) || this;
                        }
                        return class_1;
                    }(ResourceClass)),
                    _a.client = newClient,
                    _a);
            }
        }
        // Set resources available to this Sigma instance
        this.resources = resourceClasses;
    }
    Object.defineProperty(Sigma, "client", {
        get: function () {
            return base_1.default.client;
        },
        set: function (clientInstance) {
            base_1.default.client = clientInstance;
            base_1.default.client.setConcurrency(this.concurrency);
            this.events.emit('client.set', clientInstance);
        },
        enumerable: true,
        configurable: true
    });
    Sigma.setInstance = function (baseURL, token) {
        this.client = new client_1.SigmaAPIClient(baseURL, token);
        this.events.emit('instance.set', { baseURL: baseURL, token: token, client: this.client });
    };
    Sigma.clearAllCache = function () {
        Object.values(resources)
            .filter(function (resource) { return !!resource; })
            .forEach(function (resource) { return resource.clearCache(); });
    };
    Sigma.login = function (username, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, result, token, payload_1, user;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = { username: username, password: password };
                        return [4 /*yield*/, Sigma.client.post('/auth', payload)];
                    case 1:
                        result = (_a.sent());
                        token = result.data.token;
                        if (!(token && result.status > 199 && result.status < 300)) return [3 /*break*/, 3];
                        Sigma.client = new client_1.SigmaAPIClient(this.client.hostname, token);
                        payload_1 = Sigma.client.getTokenPayload();
                        return [4 /*yield*/, user_1.default.detail(String(payload_1.user_id))];
                    case 2:
                        user = _a.sent();
                        return [2 /*return*/, {
                                user: user,
                                token: token,
                                payload: payload_1,
                                response: result,
                            }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Sigma.logLevel = logger_1.level;
    Sigma.concurrency = 10;
    Sigma.events = new events_1.EventEmitter();
    return Sigma;
}());
exports.default = Sigma;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/index.js
// module id = /PZF
// module chunks = 0